document.addEventListener('DOMContentLoaded', () => {
  const breadcrumbWrappers = document.querySelectorAll('.breadcrumb-collection-wrapper');

  if (breadcrumbWrappers.length === 0) return;

  breadcrumbWrappers.forEach((wrapper) => {
    const breadcrumbDropdownToggle = wrapper.querySelector('.breadcrumb-dropdown-toggle');
    const breadcrumbDropdownMenu = wrapper.querySelector('.breadcrumb-dropdown-menu');
    const breadcrumbChevron = wrapper.querySelector('.breadcrumb-chevron');

    if (!breadcrumbDropdownToggle || !breadcrumbDropdownMenu) return;

    let isDropdownOpen = false;
    const DROPDOWN_GAP = 8;
    const VIEWPORT_PADDING = 8;

    function positionDropdown() {
      const triggerRect = breadcrumbDropdownToggle.getBoundingClientRect();
      const top = triggerRect.bottom + DROPDOWN_GAP;

      breadcrumbDropdownMenu.style.setProperty('--breadcrumb-dropdown-top', `${top}px`);
      breadcrumbDropdownMenu.style.setProperty('--breadcrumb-dropdown-left', `${triggerRect.left}px`);

      const dropdownRect = breadcrumbDropdownMenu.getBoundingClientRect();
      const maxLeft = window.innerWidth - VIEWPORT_PADDING - dropdownRect.width;
      const clampedLeft = Math.max(VIEWPORT_PADDING, Math.min(triggerRect.left, maxLeft));

      breadcrumbDropdownMenu.style.setProperty('--breadcrumb-dropdown-left', `${clampedLeft}px`);
    }

    function openDropdown() {
      document.dispatchEvent(
        new CustomEvent('breadcrumb:dropdown:opening', { detail: { wrapper } })
      );
      requestAnimationFrame(() => {
        positionDropdown();
        document.body.classList.add('!overflow-hidden');
        breadcrumbDropdownMenu.classList.remove('opacity-0', 'invisible', 'pointer-events-none');
        breadcrumbDropdownMenu.classList.add('opacity-100', 'visible');
        breadcrumbDropdownToggle.setAttribute('aria-expanded', 'true');
        if (breadcrumbChevron) {
          breadcrumbChevron.classList.add('rotate-180');
        }
        isDropdownOpen = true;
      });
    }

    function closeDropdown() {
      requestAnimationFrame(() => {
        document.body.classList.remove('!overflow-hidden');
        breadcrumbDropdownMenu.classList.remove('opacity-100', 'visible');
        breadcrumbDropdownMenu.classList.add('opacity-0', 'invisible', 'pointer-events-none');
        breadcrumbDropdownToggle.setAttribute('aria-expanded', 'false');
        if (breadcrumbChevron) {
          breadcrumbChevron.classList.remove('rotate-180');
        }
        breadcrumbDropdownMenu.style.removeProperty('--breadcrumb-dropdown-top');
        breadcrumbDropdownMenu.style.removeProperty('--breadcrumb-dropdown-left');
        isDropdownOpen = false;
      });
    }

    window.addEventListener('resize', () => {
      if (isDropdownOpen) {
        positionDropdown();
      }
    });

    function toggleDropdown() {
      if (isDropdownOpen) {
        closeDropdown();
      } else {
        openDropdown();
      }
    }

    breadcrumbDropdownToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      toggleDropdown();
    });

    document.addEventListener('click', (e) => {
      const isClickInside = breadcrumbDropdownToggle.contains(e.target) || breadcrumbDropdownMenu.contains(e.target);
      if (!isClickInside && isDropdownOpen) {
        closeDropdown();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isDropdownOpen) {
        closeDropdown();
        breadcrumbDropdownToggle.focus();
      }
    });

    document.addEventListener('breadcrumb:dropdown:opening', (e) => {
      if (e.detail?.wrapper !== wrapper && isDropdownOpen) {
        closeDropdown();
      }
    });
  });
});

